import axios from "axios";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { hostNameFunction } from "../../../utils/host-function";
import { getLocals } from "../../../getLocal";
import { addApi, editApi } from "../../../utils/apiRoute";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useRouter } from "next/router";
import { categoryNewApi } from "../../../utils/apiRoute";
import ThankYou from "../ThankYou";

export default function ListingForm({
  border,
  editData,
  button,
  width,
  heading,
  getData,
}) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [localizedStrings, setLocalizedStrings] = useState();
  const [inputValue, setInputValue] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [showThankYou, setShowThankYou] = useState(false);
  const [formData, setFormData] = useState({
    businessName: editData ? editData.businessName : "",
    category: editData ? editData.category : "",
    phoneNumber: editData ? editData.phoneNumber : "",
    email: editData ? editData.emailAddress : "",
    website: editData ? editData.website : "",
    address: editData ? editData.address : "",
    pinCode: editData ? editData.pinCode : "",
    city: editData ? editData.city : "",
    latitude: editData ? editData.latitude : "",
    longitude: editData ? editData.longitude : "",
  });
  const [isValid, setIsValid] = useState(null);
  const route = useRouter();
  useEffect(() => {
    const fetchLocalizedStrings = async () => {
      const lang = hostNameFunction() || "en";
      const strings = await getLocals(lang);
      setLocalizedStrings(strings);
    };

    fetchLocalizedStrings();
  }, []);

  const [categoryData, setCategoryData] = useState([]);

  useEffect(() => {
    getCategoryData();
  }, []);
  const getCategoryData = async () => {
    try {
      const response = await axios.post(categoryNewApi);
      setCategoryData(response.data);
    } catch (error) {
      console.error("Error fetching data for getting categories");
    }
  };

  function generateCaptcha() {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let result = "";
    for (let i = 0; i < 4; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  }

  function handleInputChange(event) {
    const value = event.target.value;
    setInputValue(value);
    if (value === captcha) {
      setIsValid(true);
      setCaptchaError("");
    } else {
      setIsValid(false);
      setCaptchaError(value.length === 0 ? "" : "Wrong Captcha");
    }
  }

  function handleChange(e) {
    const { name, value } = e.target;
    let filteredValue = value;

    if (name === "latitude" || name === "longitude") {
      // Replace non-numeric characters except periods and negative signs
      let filteredValue = value.replace(/[^0-9.-]/g, "");

      // Ensure there's only one period allowed
      if (filteredValue.indexOf(".") !== filteredValue.lastIndexOf(".")) {
        filteredValue = filteredValue.slice(0, filteredValue.lastIndexOf("."));
      }

      // Ensure there's only one negative sign at the beginning
      if (filteredValue.indexOf("-") > 0) {
        filteredValue =
          filteredValue.slice(0, 1) + filteredValue.slice(1).replace(/-/g, "");
      }

      // Ensure negative sign is at the beginning if present
      if (filteredValue.startsWith("-")) {
        filteredValue = "-" + filteredValue.slice(1).replace(/-/g, "");
      }

      // Handle cases where decimal point is at the beginning or end
      if (filteredValue.startsWith(".")) {
        filteredValue = "0" + filteredValue;
      }
      if (filteredValue.endsWith(".")) {
        filteredValue = filteredValue.slice(0, -1);
      }
    }

    if (name === "businessName" || name === "city") {
      filteredValue = value.replace(/[^A-Za-z\s]/g, ""); // Allow only letters and spaces
    } else if (name === "phoneNumber" || name === "pinCode") {
      filteredValue = value.replace(/\D/g, ""); // Allow only digits (\D is shorthand for [^0-9])

      // Limit to 10 digits if necessary
      if (name === "phoneNumber" && filteredValue.length > 10) {
        filteredValue = filteredValue.slice(0, 10);
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: filteredValue,
    }));
  }

  const onSubmit = async (data) => {
    const updatedData = {
      ...data,
      businessId: getData ? getData.id : 0,
      businessSlug: getData ? getData.slug : "",
      businessName: getData ? getData.name : formData.businessName,
    };
    try {
      if (!isValid) {
        setCaptchaError("Fill Captcha");
        return;
      }
      if (editData) {
        const response = await axios.post(editApi, updatedData);
        if (response.data.status == "success") {
          setShowThankYou(true);
        }
      } else {
        const response = await axios.post(addApi, updatedData);
        if (response.data.status == "success") {
          toast.success("Thank you!");
          route.push("/");
        } else {
          toast.error("Something went wrong! Please try Again");
          route.push("/");
        }
      }

      console.log("Form submitted successfully!", response.data);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const generateNewCaptcha = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const length = 4; // Set the length of the captcha code
    let newCaptcha = "";
    for (let i = 0; i < length; i++) {
      newCaptcha += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return newCaptcha;
  };

  const refreshCaptcha = () => {
    const newCaptcha = generateNewCaptcha();
    setCaptcha(newCaptcha);
    setInputValue("");
    setIsValid(false);
    setCaptchaError("");
  };

  return (
    <>
      {!showThankYou ? (
        <form
          className={`w-full md:${width} mx-auto ${border} mt-5 p-[24px]`}
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="mb-4">
            <p className="text-center text-xl pb-3">{heading}</p>
            <div className="flex justify-center items-center">
              <Image
                src="/assets/img/place.svg"
                className="h-[90px] w-[90px]"
                height={500}
                width={500}
                alt="image"
              />
            </div>
          </div>
          <div className="mb-5 flex flex-col">
            <div className="mb-2">
              <label>
                {localizedStrings && localizedStrings.Index.newListing.level1}
              </label>
              <input
                type="text"
                id="placeName"
                name="placeName"
                value={formData.businessName}
                {...register("businessName", {
                  required: "Place Name is required",
                  pattern: {
                    value: /^[A-Za-z\s]+$/,
                    message:
                      "Please enter place name (letters and spaces only)",
                  },
                  onChange: handleChange,
                })}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder={
                  localizedStrings &&
                  localizedStrings.Index.newListing.placeholder1
                }
              />
              {errors.businessName && (
                <span className="text-red-500 text-sm">
                  {errors.businessName.message}
                </span>
              )}
            </div>
            <div className="mb-2">
              <label>
                {localizedStrings && localizedStrings.Index.newListing.level2}
              </label>
              <select
                id="category"
                name="category"
                value={formData.category}
                {...register("category", {
                  required: "Category is required",
                  onChange: handleChange,
                })}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              >
                <option value="">
                  {localizedStrings &&
                    localizedStrings.Index.newListing.placeholder2}
                  *
                </option>
                {categoryData.map((category, index) => (
                  <option key={index} value={category.categoryName}>
                    {category.categoryName}
                  </option>
                ))}
              </select>
              {errors.category && (
                <span className="text-red-500 text-sm">
                  This field is required
                </span>
              )}
            </div>
            <div className="mb-2">
              <label>
                {localizedStrings && localizedStrings.Index.newListing.level3}
              </label>
              <input
                type="text"
                id="phoneNumber"
                name="phoneNumber"
                value={formData.phoneNumber}
                {...register("phoneNumber", {
                  required: "Phone number is required",
                  pattern: {
                    value: /^\d{10}$/, // Regex for exactly 10 digits
                    message: "Please enter a 10-digit phone number",
                  },
                  onChange: handleChange,
                })}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 "
                placeholder={
                  localizedStrings &&
                  localizedStrings.Index.newListing.placeholder3
                }
              />
              {errors.phoneNumber && (
                <span className="text-red-500 text-sm">
                  {errors.phoneNumber.message}
                </span>
              )}
            </div>
            <div className="mb-2">
              <label>
                {localizedStrings && localizedStrings.Index.newListing.level4}
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                {...register("email", {
                  required: "Email address is required",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Please enter a valid email address",
                  },
                  onChange: handleChange,
                })}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder={
                  localizedStrings &&
                  localizedStrings.Index.newListing.placeholder4
                }
              />
              {errors.email && (
                <span className="text-red-500 text-sm">
                  {errors.email.message}
                </span>
              )}
            </div>
            <div className="mb-2">
              <label>
                {localizedStrings && localizedStrings.Index.newListing.level5}
              </label>
              <input
                type="text"
                id="website"
                name="website"
                value={formData.website}
                {...register("website", {
                  required: "Website is required",
                  pattern: {
                    value:
                      /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
                    message: "Please enter a valid URL",
                  },
                  onChange: handleChange,
                })}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 "
                placeholder={
                  localizedStrings &&
                  localizedStrings.Index.newListing.placeholder5
                }
              />
              {errors.website && (
                <span className="text-red-500 text-sm">
                  {errors.website.message}
                </span>
              )}
            </div>
            <div className="mb-2">
              <label>
                {localizedStrings && localizedStrings.Index.newListing.level6}
              </label>
              <input
                type="text"
                id="address"
                name="address"
                value={formData.address}
                {...register("address", {
                  required: "Address is required", // Required validation
                  onChange: handleChange, // Custom onChange handler
                })}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 "
                placeholder={
                  localizedStrings &&
                  localizedStrings.Index.newListing.placeholder6
                }
              />
              {errors.address && (
                <span className="text-red-500 text-sm">
                  {errors.address.message}
                </span>
              )}
            </div>
            <div className="mb-2">
              <label>
                {localizedStrings && localizedStrings.Index.newListing.level7}
              </label>
              <input
                type="text"
                id="pinCode"
                name="pinCode"
                value={formData.pinCode}
                {...register("pinCode", {
                  required: "Pin Code is required",
                  pattern: {
                    value: /^\d+$/,
                    message: "Please enter pin code (digits only)",
                  },
                  onChange: handleChange,
                })}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 "
                placeholder={
                  localizedStrings &&
                  localizedStrings.Index.newListing.placeholder7
                }
              />
              {errors.pinCode && (
                <span className="text-red-500 text-sm">
                  {errors.pinCode.message}
                </span>
              )}
            </div>
            <div className="mb-2">
              <label>
                {localizedStrings && localizedStrings.Index.newListing.level8}
              </label>
              <input
                type="text"
                id="city"
                name="city"
                value={formData.city}
                {...register("city", {
                  required: "City is required",
                  pattern: {
                    value: /^[A-Za-z\s]+$/,
                    message: "Please enter city (letters and spaces only)",
                  },
                  onChange: handleChange,
                })}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 "
                placeholder={
                  localizedStrings &&
                  localizedStrings.Index.newListing.placeholder8
                }
              />
              {errors.city && (
                <span className="text-red-500 text-sm">
                  {errors.city.message}
                </span>
              )}
            </div>
            <div className="mb-2">
              <label>
                {localizedStrings && localizedStrings.Index.newListing.level9}
              </label>
              <input
                type="text"
                id="latitude"
                name="latitude"
                value={formData.latitude}
                {...register("latitude", {
                  required: "Latitude is required",
                  pattern: {
                    value: /^-?\d{1,3}(?:\.\d{1,10})?$/, // Updated pattern for latitude
                    message: "Please enter a valid latitude",
                  },
                  onChange: handleChange,
                })}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 "
                placeholder={
                  localizedStrings &&
                  localizedStrings.Index.newListing.placeholder9
                }
              />
              {errors.latitude && (
                <span className="text-red-500 text-sm">
                  {errors.latitude.message}
                </span>
              )}
            </div>
            <div className="mb-4">
              <label>
                {localizedStrings && localizedStrings.Index.newListing.level10}
              </label>
              <input
                type="text"
                id="longitude"
                name="longitude"
                value={formData.longitude}
                {...register("longitude", {
                  required: "Longitude is required",
                  pattern: {
                    value: /^-?\d{1,3}(?:\.\d{1,10})?$/, // Updated pattern for longitude
                    message: "Please enter a valid longitude",
                  },
                  onChange: handleChange,
                })}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 "
                placeholder={
                  localizedStrings &&
                  localizedStrings.Index.newListing.placeholder10
                }
              />
              {errors.longitude && (
                <span className="text-red-500 text-sm">
                  {errors.longitude.message}
                </span>
              )}
            </div>
            <div className="flex pb-2">
              <div className="text-lg font-bold border border-gray-300 px-3 py-2 inline-block mr-4">
                {captcha}
              </div>
              <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                className={`border px-3 py-2 rounded-md mr-4 ${
                  isValid === null
                    ? ""
                    : isValid
                    ? "border-green-500"
                    : "border-red-500"
                }`}
                placeholder={
                  localizedStrings &&
                  localizedStrings.Index.BusinessPage.Captcha
                }
              />
              {captchaError && (
                <span className="text-red-500 text-sm">{captchaError}</span>
              )}
              <button
                className="flex items-center px-4 py-2 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-indigo-600 rounded-lg hover:bg-indigo-500 focus:outline-none focus:ring focus:ring-indigo-300 focus:ring-opacity-80"
                onClick={refreshCaptcha}
              >
                <svg
                  className="w-5 h-5 mx-1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
            <button
              type="submit"
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              {button}
            </button>
          </div>
        </form>
      ) : (
        <ThankYou />
      )}
    </>
  );
}
